//index.ts
import { configureStore } from '@reduxjs/toolkit';  
import colorReducer from './colorSlice';  
import logoReducer from './logoSlice'; 
  
// 定义 RootState 类型，它映射了 store 中所有的 reducer  
export interface RootState {  
  themeColor: {  
    value: string;  
  };  
  logo: {
    value: string
  }
}  
  
const store = configureStore({  
  reducer: {  
    themeColor: colorReducer,  
    logo: logoReducer,
  },  
});  
  
// 导出 store 和它的类型  
export type AppDispatch = typeof store.dispatch;  
export default store;